import { useEffect, useState } from 'react';
import { toyotaPremiumWallpaperSetting } from '../../lexusOfficialAccount/utils/LinePostbackActions';

const baseUrl = (process.env.REACT_APP_BASE_URL || '').replace(/\/+$/, '');

let modelTypes = [];

export const useWallpaperSettings = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const fetchSettings = async () => {
      try {
        const response = await toyotaPremiumWallpaperSetting();
        const payload = response?.data ?? response ?? {};

        if (!isMounted) return;

        modelTypes = payload.modelTypes ?? payload ?? [];
        setIsReady(true);
      } catch (error) {
        console.error('Failed to load wallpaper settings:', error);
        setIsReady(false);
      }
    };

    fetchSettings();

    return () => {
      isMounted = false;
    };
  }, []);

  return { modelTypes, isReady };
};

export function getModelColors(modelName) {
  return modelTypes.find((type) => type.name === modelName)?.colors ?? [];
}

export function getModelImage(modelName, colorName) {
  const model = modelTypes.find((type) => type.name === modelName);
  const color = model?.colors.find((item) => item.name === colorName);

  const modelKey = model?.description;
  const colorKey = color?.description;

  if (!modelKey || !colorKey || !baseUrl) {
    return '';
  }

  return `${baseUrl}/static/wallpaper/${modelKey}/${modelKey}-${colorKey}.png`;
}

export function getBackgroundImage(colorName) {
  return `${baseUrl}/static/wallpaper/background/background-${colorName}.jpg`;
}
